import styled from "styled-components";

export const Button = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  outline: none;
  text-align: inherit;
  color: inherit;
  font: inherit;

  width: 100%;
  text-align: center;

  line-height: normal;

  -webkit-appearance: none;

  background-color: ${(props) =>
    !props.disabled ? `var(--colorUIPrimary)` : `var(--colorUIPrimary)`};
  color: ${(props) =>
    !props.disabled ? `var(--colorBackground)` : `var(--colorBackground)`};
  font-family: var(--brandFont);
  font-weight: 300;

  opacity: ${(props) => (!props.disabled ? 1 : 0.3)};

  padding: calc(var(--step-1-5) / 2) var(--step-1);
  margin: var(--step-2) 0;

  font-size: var(--step-1-75);

  &:hover {
    cursor: ${(props) => (!props.disabled ? `pointer` : `default`)};
    background-color: ${(props) =>
      !props.disabled && `var(--colorUISecondary)`};
  }
`;

export const TextInput = styled.input`
  display: block;
  width: 100%;
  padding: calc(var(--step-1-5) / 2) var(--step-1);
  margin: 0;
  margin-top: var(--gridMarginGap);
  font-size: var(--step-1-75);

  color: var(--colorContentPrimary);

  border: 1px solid var(--colorContentPrimary);

  &:focus {
    border-color: var(--colorBrandPink);
  }
`;

export const Label = styled.label`
  display: block;
  margin-top: var(--gridMarginGap);
  color: var(--colorContentPrimary);
`;
